/* eslint-disable no-undef */
// userSaga.js
import { call,  put,  takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { PRESCRIPTION_IMAGE_OPEN, PRESCRIPTION_REQUEST } from './Constants';
import { prescriptionRequestError, prescriptionRequestSuccess } from './Actions';
// import { Modal } from 'antd';



function* getPrescriptions(action) {

    try {    

        let pageNo = action.page;
        if (pageNo == null) {
            pageNo = 1;
        }
        const skip = (pageNo - 1) * 12;

        const urll = `${process.env.REACT_APP_API_BASE_URL}/prescriptionscount`;

        let headers ={
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const response1 = yield call(axios.get, urll,{ headers});
        
        const url = `${process.env.REACT_APP_API_BASE_URL}/prescription`;
  
        // // Example headers - You can add more headers as per your requirement
        headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            limit: 12,
            skip: skip,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        // // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)
  
        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
 
            yield put(prescriptionRequestSuccess(response.data, response1 && response1.data[0] && response1.data[0].total));
        } else {
            // Dispatch the failure action with the response message
            yield put(prescriptionRequestError('An error occurred.'));
        }
    } catch (error) {        
        yield put(prescriptionRequestError('An error occurred.'));
    }

}

function* prescriptionImage(action) {

    try {    
        
        const url = action.url;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        const response = yield call(axios.get, url,{ headers, responseType: 'blob'});
        if (response.status === 200 || response.status === 201) {            
            const blob = URL.createObjectURL(response.data);
            window.open(blob);  
            // yield put(healthRecordImageRequestSuccess(response.data));
        } else {
            // yield put(healthRecordImageRequestError('An error occurred.'));
        }

    } catch (error) {
        
        // yield put(healthRecordImageRequestError('An error occurred.'));
    }

}


// Watcher Saga
export function* watchFetchPrescriptions() {
    yield takeEvery(PRESCRIPTION_REQUEST, getPrescriptions);
    yield takeEvery(PRESCRIPTION_IMAGE_OPEN, prescriptionImage);
}
